import React, { useRef, useState } from 'react'
import styles from './StagePractice.module.css'
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import { shuffledArray } from '../../../../util/util';
import BottomBar from '../components/BottomBar/BottomBar';
import { saveLastScore } from '../../../../store/actions';

const StagePractice = ({
    data,
    onPageChange,
}) => {
    //console.log(data);

    const history = useHistory();

    const shuffledPositions = useRef(shuffledArray([...Array(data.sentences.length).keys()]));
    //const currPageWords = useRef(shuffledArray(data.sentences[0].heb.split(' ')))
    //const currQuestion = useRef(data.sentences[0].eng);

    const score = useRef(0);
    const wrongAnswers = useRef(0);

    const [currQuestion, setCurrQuestion] = useState(data.sentences[shuffledPositions.current[0]].eng)
    const [currPageWords, setCurrPageWords] = useState(shuffledArray(data.sentences[shuffledPositions.current[0]].heb.split(' ')))

    const [selectedWords, setSelectedWords] = useState([]);
    const [isWordSelected, setIsWordSelected] = useState(Array(data.sentences.length).fill(false))
    const [enabledCheck, setEnabledCheck] = useState(false)
    const [currIndex, setCurrIndex] = useState(0)
    const [badAnswer, setBadAnswer] = useState(false)
    const [goodAnswer, setGoodAnswer] = useState(false)
    const [transition, setTransition] = useState(false)
    const [fadeOut, setFadeOut] = useState(false);


    const dispatch = useDispatch()

    const handleWordClick = (word, index) => {
        const updatedSelectedWords = selectedWords.slice();
        updatedSelectedWords[updatedSelectedWords.length] = word
        setSelectedWords(updatedSelectedWords)

        const updatedIsSelectedWords = isWordSelected.slice();
        updatedIsSelectedWords[index] = true;
        setIsWordSelected(updatedIsSelectedWords)


        if (updatedSelectedWords.length === currPageWords.length) {
            setEnabledCheck(true)
        }
    }

    const handleRemoveWord = (word, index) => {
        const updatedSelectedWords = selectedWords.slice(0, index).concat(selectedWords.slice(index + 1, selectedWords.length));
        setSelectedWords(updatedSelectedWords)

        const updatedIsSelectedWords = isWordSelected.slice();
        const wordIndex = currPageWords.findIndex((v) => v === word)
        updatedIsSelectedWords[wordIndex] = false
        setIsWordSelected(updatedIsSelectedWords)
        if (updatedSelectedWords.length < currPageWords.length) {
            setEnabledCheck(false)
        }
    }

    const onCheck = () => {
        setEnabledCheck(false)
        if (selectedWords.join(' ') === data.sentences[shuffledPositions.current[currIndex]].heb) {
            if (wrongAnswers.current === 0) score.current += 10 / data.sentences.length
            if (wrongAnswers.current === 1) score.current += 5 / data.sentences.length
            wrongAnswers.current = 0;

            setTransition(true)
            setGoodAnswer(true)
            
            onPageChange(currIndex + 1);

            setTimeout(() => {
                setSelectedWords([])
                setGoodAnswer(false)
                setFadeOut(true)
            }, 500);

            setTimeout(() => {
                setIsWordSelected(Array(data.sentences.length).fill(false))
                setFadeOut(false)
                setTransition(false)
                const newIndex = currIndex + 1;
                setCurrIndex(newIndex)
                if (newIndex >= data.sentences.length) {
                    onFinish()
                }
                else {
                    setCurrQuestion(data.sentences[shuffledPositions.current[newIndex]].eng)
                    setCurrPageWords(data.sentences[shuffledPositions.current[newIndex]].heb.split(' '))
                }
            }, 1000)
        }
        else {
            wrongAnswers.current += 1;
            setTransition(true)
            setBadAnswer(true)

            if (wrongAnswers.current >= 2) {
                onPageChange(currIndex + 1);
            }

            setTimeout(() => {
                setSelectedWords([])
                setIsWordSelected(Array(data.sentences.length).fill(false))
                
                setBadAnswer(false)
                if (wrongAnswers.current >= 2) {
                    wrongAnswers.current = 0
                    setFadeOut(true)
                    
                }
                else {
                    setTransition(false)
                }
            }, 500);

            if (wrongAnswers.current >= 2) { 
                setTimeout(() => {
                    setIsWordSelected(Array(data.sentences.length).fill(false))
                    setFadeOut(false)
                    setTransition(false)
                    const newIndex = currIndex + 1;
                    setCurrIndex(newIndex)
                    if (newIndex >= data.sentences.length) {
                        onFinish()
                    }
                    else {
                        setCurrQuestion(data.sentences[shuffledPositions.current[newIndex]].eng)
                        setCurrPageWords(data.sentences[shuffledPositions.current[newIndex]].heb.split(' '))
                    }
                }, 1000)
            }
        }
    }

    const onFinish = () => {
        dispatch(saveLastScore(score.current))
        history.goBack();
    }

    return (
        <>
            <div
                className={styles.container}>
                <p
                    className={styles.title}
                    style={{ opacity: fadeOut ? 0 : 1 }}>{currQuestion}</p>
                <div className={styles.answerContainer}>
                    {
                        selectedWords.map((word, index) => {
                            return (
                                <p
                                    key={String(index)}
                                    className={styles.word}
                                    style={badAnswer ? { backgroundColor: '#FF6464' } : goodAnswer ? { backgroundColor: '#26C281' } : {}}
                                    onClick={() => transition ? null : handleRemoveWord(word, index)}>
                                    {word}
                                </p>
                            )
                        })
                    }
                </div>
                <div
                    className={styles.wordsContainer}
                    style={{ opacity: fadeOut ? 0 : 1 }}>
                    {
                        currPageWords.map((word, index) => {
                            return (
                                <p
                                    key={String(index)}
                                    onClick={() => isWordSelected[index] ? null : transition ? null : handleWordClick(word, index)}
                                    className={isWordSelected[index] ? styles.wordSelected : styles.word}>
                                    {word}
                                </p>
                            )
                        })
                    }
                </div>

            </div>
            <BottomBar
                mode={3}
                enabled={enabledCheck}
                onCheck={() => onCheck()} />
        </>
    )
}

export default StagePractice
